module.exports = __webpack_public_path__ + "static/kruticka_orez-ecdcee990d3932db7d1885865da513f7.png";